import { BaseModel } from '@app/shared/models/base';

export interface DefaultAreas {
    area_front_right: AreaProperty;
    area_center_right:  AreaProperty;
    area_rear_right:  AreaProperty;
    area_front_center:  AreaProperty;
    area_roof:  AreaProperty;
    area_rear_center:  AreaProperty;
    area_front_left:  AreaProperty;
    area_center_left:  AreaProperty;
    area_rear_left:  AreaProperty;
}

export interface AreaProperty {
    code: string;
    width: string;
    height: string;
    order: number;
}

export class Area extends BaseModel {
    public selected: boolean;
    public code: string;
    public width: string;
    public height: string;
    public order: number;

    constructor(json?: any) {
        super(json);
    }

    public toggleSelected(): boolean {
        this.selected = !this.selected;
        return this.selected;
    }
}
